import { Vehicle } from '@agilox/common';
import { State, States } from '@agilox/ui-common';
import { CustomDatePipe } from '@agilox/pipe/custom-date';
import { DatePipe } from '@angular/common';
import { Component, computed, input } from '@angular/core';
import { NotifyComponent } from '@agilox/ui';
import { SubscriptionRenewalButtonComponent } from '../subscription-renewal-button/subscription-renewal-button.component';
import { SubscriptionNotifyTranslationPipe } from './pipes/subscription-notify-translation.pipe';
import { SubscriptionNotifyType } from '../enums/subscription-notify-type.enum';

const SINGULAR_TRANSLATION_PREFIX = 'general.subscription_for_vehicle_';
const PLURAL_TRANSLATION_PREFIX = 'general.subscription_for_vehicles_';

@Component({
	selector: 'subscription-notify',
	templateUrl: './subscription-notify.component.html',
	imports: [NotifyComponent, SubscriptionNotifyTranslationPipe, SubscriptionRenewalButtonComponent],
	providers: [DatePipe, CustomDatePipe],
})
export class SubscriptionNotifyComponent {
	isInternalUser = input.required<boolean>();
	type = input.required<SubscriptionNotifyType>();
	userEmail = input<string>('');
	userName = input<string>('');
	vehicles = input.required<Vehicle[] | undefined>();

	notifyType = computed<State>(() =>
		this.type() === SubscriptionNotifyType.EXPIRED ? States.Warning : States.Info
	);

	singularTranslation = computed(() => SINGULAR_TRANSLATION_PREFIX + this.type());

	pluralTranslation = computed(() => PLURAL_TRANSLATION_PREFIX + this.type());
}
